import React from 'react';

export type CurrencyEnum = 'rub' | 'eur' | 'usd' | 'cad' | 'aud' | (string & {});

interface Props {
  className?: string;
  price: number | string;
  currency: CurrencyEnum;
  Container?: keyof JSX.IntrinsicElements | React.ComponentType;
}

export const FormattedPrice: React.FC<Props> = ({
  price,
  currency = 'usd',
  className,
  Container = 'span',
}) => {
  let formattedPrice = `${price} ${currency}`;

  if (currency === 'usd') {
    formattedPrice = `$${price}`;
  }
  else if (currency === 'rub') {
    formattedPrice = `${price} ₽`;
  } 
  else {
    const numericPrice: number = Number(price ?? 0);

    formattedPrice = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency.toUpperCase(),
      currencyDisplay: 'symbol',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(numericPrice);
  }

  return (
    <Container className={className} translate="no">
      {formattedPrice}
    </Container>
  )
};

FormattedPrice.displayName = 'Payments/FormattedPrice';
